const $ = jQuery

export default class Archive {
  ready () {
    const ARCHIVE_SELECTS = document.querySelectorAll('.archive-select')
    if (ARCHIVE_SELECTS.length > 0) {
      for (let i = 0; i < ARCHIVE_SELECTS.length; i++) {
        $(ARCHIVE_SELECTS[i]).change(function (e) {
          $('.archive-pagination-pages').val('')
          $('.archive-form').submit()
        })
      }
    }

    $('.mtt-archive__pagination').on('click', 'button', (e) => {
      e.preventDefault()

      const CUR_VAL = $(e.currentTarget).val()

      $(e.currentTarget).parent().parent().parent().find('input[name^="side"]').val(CUR_VAL)

      let cur_page = $('.archive-pagination-pages')
      let _pages = []
      const PAGES = $('.archive-hidden-input input[name^="side"]')

      PAGES.each((index, page) => {
        _pages.push($(page).val())
      })

      cur_page.val(_pages.join(','))

      $('.archive-form').submit()

    })

    $('.mtt-archive__topbar').on('click', 'button', (e) => {
      e.preventDefault()

      const CUR_VAL = $(e.currentTarget).val()
      let VAL = 'DESC';

      if(CUR_VAL === 'DESC'){
        VAL = 'ASC'
      }

      $(e.currentTarget).parent().next().next().find('input[name^="sort"]').val(VAL)

      let cur_sort = $('.archive-topbar-sort')
      let _sort = []
      const SORT = $('.archive-hidden-input input[name^="sort"]')

      SORT.each((index, page) => {
        _sort.push($(page).val())
      })

      cur_sort.val(_sort.join(','))

      $('.archive-form').submit()

    })

  }
}
